export default {
    GET_MENUS: "GET_MENUS",
};
